export default "__VITE_ASSET__55436d11__"